import { ApiParameters } from './api-parameters';
import { ApiGetRequest } from './api-get-request';

export class LotteryRequest extends ApiGetRequest
{
    public constructor(actuality: number, webapiBasepath: string)
    {
        const parameters = new ApiParameters();
        parameters.addQueryParameter('actuality', actuality);

        super('lottery', parameters, null, webapiBasepath);
    }
}
